import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@algoacademy/design-system/web/actions/Accordion';
import { Badge } from '@algoacademy/design-system/web/data-display/Badge';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { Tabs } from '@algoacademy/design-system/web/navigation/Tabs';
import { H3 } from '@algoacademy/design-system/web/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { endOfMonth, format } from 'date-fns';
import { useState } from 'react';
import { HourSelector, WEEK_DAYS } from './HourSelector';
type SelectedEventsByWeekDay = Record<WEEK_DAYS, string[]>;
interface FixedAvailabilityProps {
  selectedHoursByDay: SelectedEventsByWeekDay;
  setSelectedHoursByDay: React.Dispatch<React.SetStateAction<SelectedEventsByWeekDay>>;
}
export function FixedAvailability(t0) {
  const $ = _c(26);
  const {
    selectedHoursByDay,
    setSelectedHoursByDay
  } = t0;
  const [activeTab, setActiveTab] = useState(WEEK_DAYS.MONDAY);
  const [sectionOpen, setSectionOpen] = useState(false);
  const hasSelectedHours = Object.values(selectedHoursByDay).some(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const repeatUntilDate = endOfMonth(new Date());
    t1 = format(repeatUntilDate, "dd.MM.yyyy");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const repeatUntilFormatted = t1;
  let t2;
  if ($[1] !== activeTab || $[2] !== setSelectedHoursByDay) {
    t2 = hour => {
      setSelectedHoursByDay(prev => {
        const currentDayHours = prev[activeTab];
        const isSelected = currentDayHours.includes(hour);
        const newHours = isSelected ? currentDayHours.filter(h => h !== hour) : [...currentDayHours, hour];
        return {
          ...prev,
          [activeTab]: newHours
        };
      });
    };
    $[1] = activeTab;
    $[2] = setSelectedHoursByDay;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleHourForActiveDay = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <header className="flex flex-wrap items-center gap-x-3 gap-y-1"><H3>Stałe terminy spotkań</H3><P2 className="text-contentSecondary">do {repeatUntilFormatted}</P2></header>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = Object.values(WEEK_DAYS);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== selectedHoursByDay) {
    t5 = t4.map(day => ({
      label: day,
      icon: selectedHoursByDay[day].length > 0 ? <CheckCircleIcon className="h-4 w-4 text-current" /> : undefined
    }));
    $[6] = selectedHoursByDay;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = activeTab as string;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = tab => setActiveTab(tab as WEEK_DAYS);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6) {
    t8 = <Tabs tabs={t5} activeTab={t6} setActiveTab={t7} className="p-4 md:p-0" />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== activeTab || $[13] !== selectedHoursByDay || $[14] !== toggleHourForActiveDay) {
    t9 = <HourSelector activeTab={activeTab} selectedHoursByDay={selectedHoursByDay} toggleHourForActiveDay={toggleHourForActiveDay} />;
    $[12] = activeTab;
    $[13] = selectedHoursByDay;
    $[14] = toggleHourForActiveDay;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <Accordion title={t3} onToggle={setSectionOpen}><section className="space-y-4 pt-4">{t8}{t9}</section></Accordion>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== hasSelectedHours || $[20] !== sectionOpen || $[21] !== selectedHoursByDay) {
    t11 = !sectionOpen && hasSelectedHours && <div className="mt-6 flex flex-wrap gap-2">{Object.entries(selectedHoursByDay).map(_temp2)}</div>;
    $[19] = hasSelectedHours;
    $[20] = sectionOpen;
    $[21] = selectedHoursByDay;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <LightCard>{t10}{t11}</LightCard>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}
function _temp2(t0) {
  const [day_0, hours_0] = t0;
  return hours_0.length > 0 ? <Badge key={day_0} color="blueInverted" className="flex items-center gap-1 py-0.5"><CheckCircleIcon className="h-4 w-4" />{day_0}</Badge> : null;
}
function _temp(hours) {
  return hours.length > 0;
}